<template>
    <article :id="`comment-${comment.id}`" class="comment__item" :class="{ 'comment__item--attachment' : comment.attachment }">
        <div class="lc-comment-item comment__message">
            <reply v-if="comment.parent" :comment="comment.parent" />
            <span v-if="comment.message" class="comment__message__text" v-html="comment.message" />
            <attachment v-if="comment.attachment" :attachment="comment.attachment" @loaded="loaded" />
            <nav class="comment__navigation">
                <a @click.prevent.stop="$refs.reactions.toggle()" href="#" class="comment__navigation__item" v-tooltip="'Add reaction'">
                    <icon type="smiled" color="dark" size="14" />
                </a>
                <a @click.prevent="reply" href="#" class="comment__navigation__item" v-tooltip="'Reply'">
                    <icon type="arrow-reply" color="dark" size="14" />
                </a>
            </nav>
            <footer class="comment__footer">
                <span data-locator="time" class="comment__time">{{ comment.created_at | formattedTime }}</span>
            </footer>
        </div>
        <reactions ref="reactions" :comment-id="comment.id" :reactions="comment.reactions" />
    </article>
</template>

<script>
import Icon from '../../Global/Icon'
import Attachment from './Attachment'
import Reply from './Reply'
import Reactions from './Reactions'

export default {
    props: {
        comment: {
            required: true,
            type: Object
        }
    },

    methods: {
        loaded () {
            this.$emit('loaded')
        },

        reply () {
            this.$emit('reply')
        }
    },

    components: {
        Icon,
        Attachment,
        Reply,
        Reactions
    }
}
</script>
